import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Utility function to merge Tailwind CSS classes with clsx
 * This ensures that Tailwind classes are properly merged and conflicting classes are resolved
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}